import { useEffect, useRef } from 'react';
import { usePage } from '@inertiajs/react';
import posthog from 'posthog-js';
import { getAnalyticsContext, type AnalyticsPageProps } from '@/lib/analytics';

type AnalyticsRole = 'anonymous' | 'patient' | 'therapist' | 'admin';

const EVENT_VERSION = 1;

export function PosthogTracker() {
  const page = usePage();
  const previousRoleRef = useRef<AnalyticsRole>('anonymous');

  useEffect(() => {
    const { environment, source, role, distinctId } = getAnalyticsContext(
      page.props as AnalyticsPageProps,
      (page.url as string) || window.location.pathname,
    );

    const wasAnonymous = previousRoleRef.current === 'anonymous';
    const isAnonymous = role === 'anonymous';

    if (!wasAnonymous && isAnonymous) {
      posthog.reset();
    }

    posthog.register({
      environment,
      source,
      role,
      event_version: EVENT_VERSION,
    });

    if (!isAnonymous && distinctId) {
      posthog.identify(distinctId);
    }

    previousRoleRef.current = role;
  }, [page.props, page.url]);

  return null;
}
